export default "__VITE_ASSET__Djow1jme__"